import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavigationDrawer } from '@/components/NavigationDrawer';

export function PublicHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  // Lock background scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const handleSignUp = () => {
    setIsMenuOpen(false);
    navigate('/auth?mode=signup');
  };

  const handleSignIn = () => {
    setIsMenuOpen(false);
    navigate('/auth?mode=signin');
  };

  // Check current page to avoid redundant navigation
  const isOnAuthPage = location.pathname === '/auth';
  const isSignUpMode = new URLSearchParams(location.search).get('mode') === 'signup';

  return (
    <>
      {/* Header */}
      <header className="p-4 border-b border-border sticky top-0 bg-background z-40">
        <div className="flex items-center justify-between max-w-lg mx-auto px-0">
          <div className="w-9" /> {/* Spacer for balance */}
          <h1 className="text-xl font-serif font-bold">{t('landingHeroTitle')}</h1>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="p-2 bg-primary/10 hover:bg-primary/20 rounded-full"
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? (
              <X className="h-5 w-5 text-primary" />
            ) : (
              <Menu className="h-5 w-5 text-primary" />
            )}
          </Button>
        </div>
      </header>

      {/* Navigation Drawer */}
      <NavigationDrawer
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        isAuthenticated={false}
        onSignUp={handleSignUp}
        onSignIn={handleSignIn}
        hideSignUp={isOnAuthPage && isSignUpMode}
        hideSignIn={isOnAuthPage && !isSignUpMode}
      />
    </>
  );
}
